import { Left } from '@playq/irt';
import { OnlineDevicesSubscriptionServiceClient, type DeviceStatus } from '@playq/octopus2-devices';
import { GenericFailure } from '@playq/services-shared';

import { websocketTransport, tryToSendEphemeral } from '../../core';

const onlineSubscriptionSocket = new OnlineDevicesSubscriptionServiceClient(websocketTransport);

const onlineDevicesDefaultResolver = () =>
  Promise.resolve(new Left<GenericFailure, DeviceStatus>(new GenericFailure()));

export const onlineDevicesEphemeral = {
  sendSubscription: async (...args: Parameters<typeof onlineSubscriptionSocket.subscribe>) =>
    tryToSendEphemeral(() => onlineSubscriptionSocket.subscribe(...args), onlineDevicesDefaultResolver),

  sendUnsubscription: async (...args: Parameters<typeof onlineSubscriptionSocket.unsubscribe>) =>
    tryToSendEphemeral(() => onlineSubscriptionSocket.unsubscribe(...args), onlineDevicesDefaultResolver),
};
